import { Button, Grid } from "@mui/material";
// import Filter from "common/Select/SelectMultiFilter";
import { useTranslation } from "react-i18next";
import { themes } from "theme/themes";
import { brandingInfo } from "features/server/brandingSlice";
import { useSelector } from "react-redux";
import dayjs from "dayjs";
import DateRangePicker from "common/Pickers/DateRangePicker";
import DynamicSelect from "common/Select/Select";

interface ReviewSearchHeaderComponentProps {
  handleChangeFilter: (event: any) => void;
  handleChangeSearch: (field: string, value: any) => void;
  handleSubmitSearch: () => void;
  searchFormData: any;
  filter: string[];
  clearSearch: () => void;
  search: any;
  RatingList: any;
}

const ReviewSearchHeader: React.FC<ReviewSearchHeaderComponentProps> = ({
  //   handleChangeFilter,
  handleChangeSearch,
  handleSubmitSearch,
  searchFormData,
  filter,
  clearSearch,
  search,
  RatingList,
}) => {
  const { t } = useTranslation();
  const branding = useSelector(brandingInfo);
  const themeColors =
    branding?.attributes?.themeId === 100
      ? branding?.attributes?.customTheme
      : (themes as any)[branding?.attributes?.themeId || 3];
  //   const filterOptions = ['rating', 'dateInterval'];
  const handleKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      handleSubmitSearch();
    }
  };
  return (
    <>
      <Grid container spacing={1} className="mb-2">
        {/* <Grid item xs={12} sm={6} md={3}>
          <Filter 
            label="Filter By"
            filterOptions={filterOptions}
            handleChangeFilter={handleChangeFilter}
            filter={filter}
          />
        </Grid> */}
        {filter.map((fieldName) =>
          fieldName === "dateInterval" ? (
            <Grid
              item
              key={fieldName}
              xs={12}
              sm={6}
              md={3}
              className="max-w-[fit-content]"
            >
              <DateRangePicker
                label={t("dateInterval")}
                maxDate={dayjs()}
                placeholder={"YYYY-MM-DD → YYYY-MM-DD"}
                onChange={(value) =>
                  handleChangeSearch("dateInterval", [
                    value?.[0] ? value[0].format("YYYY-MM-DD") : null,
                    value?.[1] ? value[1].format("YYYY-MM-DD") : null,
                  ])
                }
                value={[
                  searchFormData?.startDate
                    ? dayjs(searchFormData.startDate)
                    : null,
                  searchFormData?.endDate
                    ? dayjs(searchFormData.endDate)
                    : null,
                ]}
              />
            </Grid>
          ) : (
            <Grid item key={fieldName} xs={12} sm={6} md={3}>
              <DynamicSelect
                value={RatingList.find(
                  (option: any) => option.value === searchFormData?.rating,
                )}
                isDisabled={false}
                isLoading={false}
                isClearable={false}
                isRtl={false}
                isSearchable={true}
                name="rating"
                options={RatingList}
                isRequired={false}
                onChange={(e) => handleChangeSearch("rating", e)}
                label={t("rating")}
                onKeyDown={handleKeyPress}
                defaultPlaceholder={t("rating")}
              />
            </Grid>
          ),
        )}
        <Grid
          item
          xs={12}
          sm={6}
          md={2}
          sx={{ display: "flex", alignItems: "flex-end", gap: 1 }}
        >
          <Button
            variant="contained"
            disabled={filter.length ? false : true}
            onClick={handleSubmitSearch}
            sx={{
              boxShadow: "none",
              background: filter.length > 0 ? themeColors?.primary : "#B8C0C6",
            }}
            className={`text-white text-ellipsis overflow-hidden font-Saira font-[600] text-[13px] h-[35px] px-8 py-1`}
          >
            {t("submit")}
          </Button>
          {(filter.length && Object.keys(search).length) ||
          filter.length > 1 ? (
            <Button
              variant="contained"
              onClick={clearSearch}
              sx={{ boxShadow: "none", color: themeColors?.primary }}
              className={`text-ellipsis overflow-hidden font-Saira font-[600] text-[13px] bg-[#d8d1e0] h-[35px] px-8 py-1`}
            >
              {t("clear")}
            </Button>
          ) : null}
        </Grid>
      </Grid>
    </>
  );
};

export default ReviewSearchHeader;
